import { render, staticRenderFns } from "./approval-collapsible.vue?vue&type=template&id=0f7edd28"
import script from "./approval-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./approval-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./approval-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7edd28')) {
      api.createRecord('0f7edd28', component.options)
    } else {
      api.reload('0f7edd28', component.options)
    }
    module.hot.accept("./approval-collapsible.vue?vue&type=template&id=0f7edd28", function () {
      api.rerender('0f7edd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/approval-collapsible/approval-collapsible.vue"
export default component.exports